import React, { PureComponent } from 'react';
import ReactHtmlParser from 'react-html-parser';

import Tooltip from '@material-ui/core/Tooltip';

import { Notes } from './Notes';
import { AddEditNote } from './AddEditNote';

import { API } from '../../../ws/constants';

import './style.css';

var moment = require('moment');

const CATEGORIES = {
    OTHERS: {
        ID: 999,
        NAME: "Outros"
    }
}

export class Notepad extends PureComponent {
    date = moment();
    state = {
        tableLoading: false,
        categoryId: 0,
        editNoteId: "New",
        categoryName: "",
        defaultCatId: 1,
        categories: []
    };

    componentDidMount() {
        this.setState({ tableLoading:true });

        fetch(API + "getnotescategories")
        .then(response => response.json())
        .then(data => this.setState({ categories: data.data, categoryName: data.data[0].Name, tableLoading:false }));
    }

    onAddNewNote = (e) => this.setState({ categoryId: 0, defaultCatId: e.currentTarget.dataset.catId, editNoteId: "New" });
    onEditNote = (e) => this.setState({ categoryId: 0, editNoteId: e.currentTarget.dataset.noteId });
    onBackClick = (catId) => this.setState({ categoryId: catId });

    getSelectedNotes = (e) => {
        this.setState({ 
            categoryId: parseInt(e.currentTarget.dataset.noteCategory),
            categoryName: e.currentTarget.dataset.noteCategoryName || "",
            defaultCatId: 1,
            editNoteId: "New",
        });
    }  

    render() {
        const { isAdmin, loginData, newNotes } = this.props;
        const { categories, categoryId, categoryName, defaultCatId, editNoteId } = this.state;
        const loadingClass = this.state.loading ? " ajaxLoading" : "";
        const newOtherNotes = newNotes.filter(x => parseInt(x.CategoryId) === CATEGORIES.OTHERS.ID);

        return (
            <div id="notepadPage" className={loadingClass}>
                <div ref="editForm" className="form">
                    <div className="row">
                        <div className="col-11">
                            {
                                categoryId ? 
                                <Notes 
                                    key={newNotes}
                                    isAdmin={isAdmin}
                                    loginData={loginData}
                                    categoryName={categoryName}
                                    categoryId={categoryId}
                                    onAddNewNote={this.onAddNewNote}
                                    onEditNote={this.onEditNote}
                                    newNotes={newNotes.filter(x => parseInt(x.CategoryId) === categoryId)}
                                />
                                :
                                <AddEditNote
                                    isAdmin={isAdmin}
                                    loginData={loginData}
                                    noteId={editNoteId}
                                    catId={defaultCatId}
                                    onBackClick={this.onBackClick}
                                    isNewNote={editNoteId !== "New" ? newNotes.find(x => x.Id === editNoteId) : []}
                                    getUnseenNotes={this.props.getUnseenNotes}
                                />
                            }
                        </div>
                        <div className="markersHolder text-right">
                            { (isAdmin || loginData.profile.Notepad.ADD) && 
                                <Tooltip
                                    title={"Adicionar Nota"}
                                    enterDelay={200}>
                                    <button className={"actionButton marker successText" + (!categoryId ? " active" : "")} data-note-category={0} onClick={this.getSelectedNotes}><i className="fa fa-plus"></i></button>
                                </Tooltip>
                            }
                            {
                                categories.map(noteCat => {
                                    const noteNewNotes = this.props.newNotes.filter(x => x.CategoryId === noteCat.Id);
                                    
                                    return (<Tooltip
                                        title={noteCat.Name}
                                        enterDelay={200}
                                        key={noteCat.Id}>
                                            <button className={"actionButton marker" + (categoryId === parseInt(noteCat.Id) ? " active" : "")} data-note-category={noteCat.Id} data-note-category-name={noteCat.Name} style={{background: noteCat.BackgroundColor, color: noteCat.TextColor}} onClick={this.getSelectedNotes}>
                                                {ReactHtmlParser(noteCat.Icon)}
                                                {Boolean(noteNewNotes.length) && <span className="newNotes">{noteNewNotes.length}</span>}
                                            </button>
                                    </Tooltip>);
                                })
                            }
                            <Tooltip
                                title={CATEGORIES.OTHERS.NAME}
                                enterDelay={200}>
                                <button className={"actionButton marker" + (categoryId === parseInt(CATEGORIES.OTHERS.ID) ? " active" : "")} data-note-category={CATEGORIES.OTHERS.ID} data-note-category-name={CATEGORIES.OTHERS.NAME} style={{background: "#ccc", color: "#000"}} onClick={this.getSelectedNotes}>
                                    <i className="fa fa-globe-europe"></i>
                                    {Boolean(newOtherNotes.length) && <span className="newNotes">{newOtherNotes.length}</span>}
                                </button>
                            </Tooltip>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
